module.exports = __webpack_public_path__ + "img/select-path.507db145.jpg";